import { Image, View } from 'react-native';

export const FillerBody = () => {
  return (
    <View className="flex-1 w-full h-full justify-center items-center">
      <Image
        source={require('../../assets/neolexon_Logo_ohneClaim.png')}
        alt={'NEOLEXON LOGO'}
        className="rounded-lg shadow-md"
        resizeMode="cover"
      />
    </View>
  );
};
